module.exports = __webpack_public_path__ + "img/next stop.7196df1e.png";